// ─────────────────────────────────────────────────────────────────────────────
// MethodRow — the payment-method picker.
//
// Horizontal row of chips: Transfer (active), Pay by Account, Card, USSD.
// Only Transfer is wired today. The other three exist as aria-disabled
// chips to establish the design pattern for future methods — when a method
// goes live, flip aria-disabled and wire its handler.
//
// Why the placeholders are present rather than hidden:
//   Session 51 founder direction (§ "futuristic / room for others"): the
//   UI should show that additional payment methods are coming, not hide
//   them until ready. Trust signal — this isn't a thin shell, it's a
//   platform Posteering is building out.
//
// Why MethodRow takes no props today:
//   The BFF's PublicCheckoutResponse has no paymentMethod or supportedMethods
//   field. The method selection is purely a frontend concept right now
//   (the intent is always a bank-transfer VA). When a paymentMethod field
//   is added to the BFF contract, this component grows a prop to render
//   only the enabled methods.
// ─────────────────────────────────────────────────────────────────────────────

export function MethodRow() {
  return (
    <div className="method-row-wrap">
      <div className="method-row-label">Pay with</div>
      <div className="method-row" role="tablist" aria-label="Payment methods">

        {/* Transfer — active */}
        <button
          type="button"
          role="tab"
          aria-pressed="true"
          className="method"
        >
          <span className="method-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M3 11l18-7-3 18-7-6-5-2-3-3z"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="method-label">Transfer</span>
        </button>

        {/* Pay by Account — future: account number + bank token auth */}
        <button
          type="button"
          role="tab"
          aria-pressed="false"
          aria-disabled="true"
          className="method"
        >
          <span className="method-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M3 21h18M3 10h18M5 6l7-4 7 4M4 10v11M8 10v11M12 10v11M16 10v11M20 10v11"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="method-label">Pay by Account</span>
        </button>

        {/* Card — future */}
        <button
          type="button"
          role="tab"
          aria-pressed="false"
          aria-disabled="true"
          className="method"
        >
          <span className="method-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <rect x="2" y="5" width="20" height="14" rx="2" />
              <path d="M2 10h20" />
            </svg>
          </span>
          <span className="method-label">Card</span>
        </button>

        {/* USSD — future */}
        <button
          type="button"
          role="tab"
          aria-pressed="false"
          aria-disabled="true"
          className="method"
        >
          <span className="method-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <rect x="5" y="2" width="14" height="20" rx="2" />
              <path d="M12 18h.01" />
            </svg>
          </span>
          <span className="method-label">USSD</span>
        </button>

      </div>
    </div>
  );
}
